import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignmentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAlignmentRight"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H21V6H3V4ZM3 4H21V6H3V4ZM3 4H21V6H3V4Z" fill="currentColor"/><Path d="M21 11V13H11V11H21Z" fill="currentColor"/><Path d="M21 18V20H3V18H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignmentRight;
